import { render, staticRenderFns } from "./AdminMilestoneButton.vue?vue&type=template&id=e722779e"
import script from "./AdminMilestoneButton.vue?vue&type=script&lang=js"
export * from "./AdminMilestoneButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports